<template>
    <div class="settings-clients">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Clientes</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <div class="submenu">
                    <mu-menu cover placement="left-start" class="menu-mobile">
                        <mu-button icon>
                            <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
                        </mu-button>
                        <mu-list slot="content" class="mu-list-custom">
                            <mu-list-item button v-for="(item, key) in submenu" :to="{ name: item.route }" :color="item.color" :textColor="item.textColor" :key="key">
                                <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/></mu-list-item-action>
                            </mu-list-item>
                        </mu-list>
                    </mu-menu>
                    <div class="menu-desktop">
                        <mu-flex>
                            <mu-button v-for="(item, key) in submenu" :to="{ name: item.route }" round :color="item.color" :textColor="item.textColor" :key="key">
                                <font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/>
                                {{ item.name }}
                            </mu-button>
                        </mu-flex>
                    </div>
                </div>
            </mu-col>
        </mu-row>

        <!-- Busca de clientes -->
        <div class="search">
            <mu-form :model="filter">
                <mu-paper :z-depth="1">
                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <mu-text-field v-model="filter.name" full-width @keyup.enter="filterLoad()" label="Nome/Nome Fantasia"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <mu-text-field v-model="filter.document" v-mask="['##.###.###/####-##','###.###.###-##']" full-width @keyup.enter="filterLoad()" label="CNPJ/CPF"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <mu-select label="Tipo Documento" v-model="filter.person_type" full-width>
                                <mu-option v-for="(option, key) in options.person_type" :key="key" :label="option.label" :value="option.value"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <mu-select label="Tipo Cliente" v-model="filter.custom_type" full-width>
                                <mu-option v-for="(option, key) in options.custom_type" :key="key" :label="option.label" :value="option.value"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <mu-select label="Status" v-model="filter.status" full-width>
                                <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <div class="padding-top">
                                <mu-button round color="secondary" @click="filterLoad()">
                                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                    Filtrar
                                </mu-button>
                                <mu-button round @click="filterClear()">
                                    <font-awesome-icon icon="times" class="icon-md icon-margin-left"/>
                                    Limpar
                                </mu-button>
                            </div>
                        </mu-col>
                    </mu-row>
                </mu-paper>
            </mu-form>
        </div>

        <!-- Listagem de clientes -->
        <div class="clients" v-if="!clients.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos clientes -->
                <mu-data-table :columns="clients.columns" :data="clients.list" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de clientes
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ getCustomType(scope.row.custom_type) }}</td>
                        <td ><router-link :to="{ name: 'app.settings.clients.edit', params: { id: scope.row.id } }">{{ scope.row.nick_name }}</router-link></td>
                        <td class="is-center"><mu-button flat class="btn-user" to="#" v-on:click="openDialogUsers(scope.row.id, scope.row.nick_name)">Ver Usuários</mu-button></td>
                        <td>{{ scope.row.document_id }}</td>
                        <td>{{ getTypeName(scope.row.person_type) }}</td>
                        <td class="btn-key is-center"><mu-button color="#fbc02d" flat v-on:click="openDialogKeyAPI(scope.row.id)"><font-awesome-icon icon="key" class="icon-md"/></mu-button></td>
                        <td class="is-center">
                            <mu-badge content="Inativo" v-if="scope.row.status != 'A'"></mu-badge>
                            <mu-badge content="Ativo" v-if="scope.row.status == 'A'" color="success"></mu-badge>
                        </td>
                    </template>
                </mu-data-table>

                <!-- DIALOGS -->
                <mu-dialog title="Chaves de API" width="360" :open.sync="openKeyAPI" class="dialog-key">
                    <ul v-if="datakeyAPI.length > 0">
                        <li v-for="(item, key) in datakeyAPI" :key="key">
                            <span class="name">{{ item.services.name }}</span>
                            <span class="key" v-if="item.ch1_key">{{ item.ch1_key }}</span>
                            <span v-else>Nenhuma chave para este serviço.</span>
                        </li>
                    </ul>
                    <mu-button slot="actions" flat color="primary" @click="closeDialogKeyAPI">Fechar</mu-button>
                </mu-dialog>

                <mu-dialog :title="dialogUsersTitle" width="800" :open.sync="dialogUsers" class="dialog-users" scrollable>
                    <mu-data-table :columns="userData.columns" :data="userData.list" v-if="viewport !== 'mobile'" class="mu-table-custom">
                        <template slot="empty">
                            <div class="box-table-empty">
                                Não foi encontrado registros de usuários
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <td class="is-center">{{ scope.row.login }}</td>
                            <td class="is-center">{{ scope.row.email }}</td>
                            <td class="is-center">{{ scope.row.lastlogin ? dateFormat(scope.row.lastlogin) : 'Não Fez' }}</td>
                            <td class="is-center"><mu-button round small color="#8a2c8a" v-on:click="refreshPassword(scope.row.login)" class="btn-password"><font-awesome-icon icon="envelope" class="resend" /> Reenviar</mu-button></td>
                        </template>
                    </mu-data-table>
                </mu-dialog>
                <!-- FIM DOS DIALOGS -->

                <!-- Listagem de palavras chave mobile -->
                <mu-list textline="three-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in clients.list" :key="key">
                        <mu-list-item button :to="{ name: 'app.settings.clients.edit', params: { id: item.id } }">
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.nick_name }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    {{ item.document_id }} <br>
                                    <mu-badge content="Inativo" v-if="item.status != 'A'"></mu-badge>
                                    <mu-badge content="Ativo" v-if="item.status == 'A'" color="success"></mu-badge>
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="pen" class="icon-md icon-margin-left"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="clients.paging.total > clients.paging.size">
                <mu-pagination :total="clients.paging.total" :page-count="5" :page-size="clients.paging.size" :current.sync="clients.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de clientes" v-if="clients.loading"></mu-loading>
        <mu-loading-dialog message="Enviando nova senha" :visible="userData.tableLoading"></mu-loading-dialog>

    </div>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import ClientsServices from '@/services/settings/clients'
    import ChannelsServices from '@/services/settings/channels-clients'

    export default {
        name: 'app-settings-clients',

        // ╔╦╗╦╦═╗╔═╗╔═╗╔╦╗╦╦  ╦╔═╗╔═╗
        //  ║║║╠╦╝║╣ ║   ║ ║╚╗╔╝║╣ ╚═╗
        // ═╩╝╩╩╚═╚═╝╚═╝ ╩ ╩ ╚╝ ╚═╝╚═╝
        directives: {
            mask
        },

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Clientes',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Cliente',
                        icon: 'plus',
                        route: 'app.settings.clients.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                options: {
                    person_type: [
                        { value: '', label: 'Todos' },
                        { value: 'PF', label: 'Pessoa Física' },
                        { value: 'PJ', label: 'Pessoa Jurídica' }
                    ],
                    custom_type: [
                        { value: '', label: 'Todos' },
                        { value: 'R', label: 'Revenda' },
                        { value: 'C', label: 'Cliente' }
                    ],
                    status: [
                        { value: '', label: 'Todos' },
                        { value: 'A', label: 'Ativos' },
                        { value: 'I', label: 'Inativos' }
                    ]
                },
                search: {
                    visible: false
                },
                filter: {
                    name: '',
                    document: '',
                    person_type: '',
                    custom_type: '',
                    status: ''
                },
                clients: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 15,
                        total: 0
                    },
                    columns: [
                        { title: 'Tipo', name: 'custom', width: '100' },
                        { title: 'Nome', name: 'name' },
                        { title: 'Usuários', name: 'users', align: 'center', width: '200' },
                        { title: 'Documento', name: 'document', width: '220' },
                        { title: 'Tipo', name: 'type', width: '200' },
                        { title: 'Chaves API', name: 'key', align: 'center', width: '180' },
                        { title: 'Status', name: 'status', align: 'center', width: '150' }
                    ],
                    list: []
                },
                openKeyAPI: false,
                datakeyAPI: [],
                dialogUsers: false,
                dialogUsersTitle: 'Listagem de usuários',
                userData: {
                    tableLoading: false,
                    columns: [
                        { title: 'Login', name: 'login', align: 'center' },
                        { title: 'E-mail', name: 'email', align: 'center', width: '250' },
                        { title: 'Último login', name: 'lastlogin', align: 'center' },
                        { title: 'Ação', name: 'action', align: 'center', width: '200' }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        async created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            async openDialogKeyAPI (clientId) {
                try {
                    // this.clients.loading = true

                    let result = await ChannelsServices.find(clientId)

                    if (result && result.status) {
                        this.openKeyAPI = true
                        this.datakeyAPI = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    // this.clients.loading = false
                }
            },

            closeDialogKeyAPI () {
                this.openKeyAPI = false
            },

            async openDialogUsers (userId, userLogin) {
                try {
                    let result = await ClientsServices.usersList(userId)

                    if (result && result.status) {
                        this.dialogUsers = true
                        this.dialogUsersTitle = `Usuários da ${userLogin}`
                        this.userData.list = result.results
                        return
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                }
            },

            async refreshPassword (login) {
                try {
                    this.userData.tableLoading = true
                    let data = {
                        UserName: login
                    }

                    let result = await ClientsServices.usersPassword(data)

                    if (result && result.status) {
                        this.userData.tableLoading = false
                        this.$eventHub.$emit('snackbar', 'success', 'Senha reenviada com sucesso!')
                        return
                    }
                } catch (e) {
                    this.userData.tableLoading = false
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.userData.tableLoading = false
                }
            },

            /**
             * Método responsável por direcionar para tela de edição do item
             * esse item é chamado em cada linha da listagem
             */
            edit (index, row, event) {
                this.$router.push({ name: 'app.settings.clients.edit', params: { id: row.id } }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Carrega a lista de clientes passando a paginação
             */
            async load () {
                try {
                    this.clients.loading = true

                    let params = {
                        page: this.clients.paging.page
                    }

                    if (this.filter.name) {
                        params.name = this.filter.name
                    }

                    if (this.filter.document) {
                        params.document = this.filter.document
                    }

                    if (this.filter.person_type) {
                        params.person_type = this.filter.person_type
                    }

                    if (this.filter.custom_type) {
                        params.custom_type = this.filter.custom_type
                    }

                    if (this.filter.status) {
                        params.status = this.filter.status
                    }

                    let result = await ClientsServices.findAll(params)

                    if (result && result.status) {
                        this.clients.paging.page = result.currentPage
                        this.clients.paging.total = result.rowCount
                        this.clients.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.clients.loading = false
                }
            },

            /**
             * Método retorna o nome do tipo do cliente, é chamado na listagem
             * de clientes em uma coluna
             */
            getTypeName (type) {
                switch (type) {
                case 'PJ':
                    return 'Pessoa Jurídica'
                case 'PF':
                    return 'Pessoa Física'
                default:
                    return '-'
                }
            },

            /**
             * Método retorna se é revenda ou cliente, é chamado na listagem
             * de clientes em uma coluna
             */
            getCustomType (type) {
                switch (type) {
                case 'R':
                    return 'Revenda'
                case 'C':
                    return 'Cliente'
                default:
                    return '-'
                }
            },

            filterLoad () {
                this.clients.paging.page = 1
                this.load()
            },

            /**
             * Limpa os campos do filtro e refaz o load original
             */
            filterClear () {
                this.filter = {
                    name: '',
                    document: '',
                    person_type: '',
                    custom_type: '',
                    status: ''
                }
                this.clients.paging.page = 1
                this.clients.paging.size = 15
                this.load()
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .search
        margin 20px 0

        .row
            .mu-input
                margin-bottom 0

        .mu-paper
            padding 10px 20px 20px 20px

        .padding-top
            padding-top 28px

    .clients
        margin 20px 0

        .mu-list
            padding 0

        a
            color inherit
            text-decoration underline

        .row
            margin 0 20px
            padding 15px 0

            .text-right
                text-align right

        .paginate
            padding 20px

        .mu-paper
            padding 0px

    .mu-button-float-right
        float right
        margin-left 5px

    .submenu
        float right

        .mu-button
            margin-left 5px

    .btn-key
        .mu-button
            text-transform: inherit
            font-size: 13px
            .hover
                background: inherit
            .mu-button-wrapper
                padding: 0
                margin: 0

    .dialog-key
        ul
            padding: 0
            margin: 0
            li
                display: block
                list-style: none
                border-bottom: 1px dashed #8a2c8a
                &:last-child
                    border: none
                margin-bottom: 10px
                padding-bottom: 10px
                span
                    display: block
                    &.name
                        color: #8a2c8a
                        font-weight bold

    .btn-user
        font-size 13px
        text-transform inherit
        vertical-align middle

    .btn-password
        padding 0 5px
        svg
            margin-right: 5px;
</style>
